import { useEffect, useState } from 'react';
import { getApiErrorMessage, portalApi } from '../../api/client';
import type { DisputeRow } from '../../api/types';
import { FinancialGuard } from '../../components/Layout/FinancialGuard';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { formatAmount, formatDate } from '../../utils/format';

export function DisputesPage() {
  const [rows, setRows] = useState<DisputeRow[]>([]);
  const [err, setErr] = useState('');

  const load = () => {
    void portalApi.listDisputes().then((r) => setRows(r.disputes ?? [])).catch((e) => setErr(getApiErrorMessage(e)));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <FinancialGuard>
      <div className="space-y-6">
        <h2 className="font-display text-2xl">Disputes & chargebacks</h2>
        {err ? <p className="text-sm text-onyx-danger">{err}</p> : null}
        <Card>
          <table className="data-table">
            <thead>
              <tr>
                <th>Transaction</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Deadline</th>
                <th>Evidence</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((d) => (
                <tr key={d.id}>
                  <td className="font-mono text-xs">{d.signature?.slice(0, 12) ?? d.transaction_id.slice(0, 8)}…</td>
                  <td>{formatAmount(d.amount_display, d.currency)}</td>
                  <td><Badge status={d.status} /></td>
                  <td className="text-xs">{formatDate(d.deadline_at)}</td>
                  <td>
                    <label className="cursor-pointer">
                      <span className="sr-only">Upload evidence</span>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        className="text-xs"
                        onChange={async (e) => {
                          const f = e.target.files?.[0];
                          if (!f) return;
                          try {
                            await portalApi.uploadDisputeEvidence(d.id, `evidence://${d.id}/${f.name}`);
                            load();
                          } catch (ex) {
                            setErr(getApiErrorMessage(ex));
                          }
                        }}
                      />
                      <Button variant="ghost" className="text-xs py-1 px-2" type="button">
                        Upload
                      </Button>
                    </label>
                  </td>
                </tr>
              ))}
              {!rows.length ? (
                <tr>
                  <td colSpan={5} className="text-center text-onyx-muted py-8">
                    No open disputes
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </Card>
      </div>
    </FinancialGuard>
  );
}
